import { configureStore } from "@reduxjs/toolkit";
import { counterSlice } from "./slices/counterSlice";
import authSlice from "./slices/authSlice";
import databaseSlice from "./slices/databaseSlice";

export const store = configureStore({
    // reducer: counterSlice.reducer,
    reducer: {
        auth: authSlice,
        database: databaseSlice
    }
})